import WatermarkRemover from './WatermarkRemover';
import type { User } from '@supabase/supabase-js';

interface WatermarkRemoverClientProps {
  user: User | null;
}

/**
 * Client wrapper for WatermarkRemover
 *
 * CLS FIX: Renders the actual component directly instead of swapping
 * between placeholder and real component. The WatermarkRemover uses
 * static default state values, so the initial render is hydration-safe.
 *
 * suppressHydrationWarning is used on the outer div to handle any
 * minor differences that may occur between SSR and client render.
 */
export default function WatermarkRemoverClient({ user }: WatermarkRemoverClientProps) {
  return (
    <div suppressHydrationWarning>
      <WatermarkRemover user={user} />
    </div>
  );
}
